"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridPaginationId = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const controls_1 = require("../../controls");
const features_1 = require("../features");
const PagingWrap = styled_components_1.default.div `
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
exports.gridPaginationId = 'grid-pagination';
const GridPagination = (props) => {
    var _a;
    const { state: { data, pagination, disabled } } = (0, features_1.useGridContext)();
    const isDataExist = data.length > 0;
    if (!pagination) {
        return null;
    }
    if (!props.forcePagination && !isDataExist) {
        return null;
    }
    if (pagination.isCompact && isDataExist) {
        return (react_1.default.createElement(PagingWrap, { "data-selector-id": exports.gridPaginationId },
            react_1.default.createElement(controls_1.CompactPagination, { currentPage: pagination.showCurrentPageInCompact ? pagination.activePage : undefined, hasPrev: pagination.activePage > 1, hasNext: pagination.activePage < pagination.fullPages, onPrevClick: () => { var _a; return (_a = pagination.onPageChange) === null || _a === void 0 ? void 0 : _a.call(pagination, pagination.activePage - 1); }, onNextClick: () => { var _a; return (_a = pagination.onPageChange) === null || _a === void 0 ? void 0 : _a.call(pagination, pagination.activePage + 1); }, disabled: disabled })));
    }
    return (react_1.default.createElement(PagingWrap, { "data-selector-id": exports.gridPaginationId },
        react_1.default.createElement(controls_1.Pagination, { activePage: pagination.activePage, lastPage: pagination.fullPages, onPageClick: pagination.onPageClick, onPageChange: pagination.onPageChange, disabled: disabled, texts: (_a = props.texts) === null || _a === void 0 ? void 0 : _a.pagination })));
};
exports.default = GridPagination;
//# sourceMappingURL=GridPagination.js.map